/**
 * Configuration globale de PDF.js
 * Initialise le worker nécessaire pour react-pdf
 */

import {pdfjs} from 'react-pdf';

// Configurer le worker PDF.js via CDN
// Alternative: utiliser un fichier local avec `pdfjs-dist/build/pdf.worker.min.js`
//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export default pdfjs;
